/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { Field, FieldArray, Form, Formik } from "formik";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
// Formik and Yup

import { useFormik } from "formik";
import * as Yup from "yup";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Modal from "@mui/material/Modal";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import TextError from "utils/TextError";
// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CancelIcon from "@mui/icons-material/Clear";

// Functions from store
import {
  createCalendar,
  deleteCalendar,
  getCalendars,
  getSubModulesByRoleId,
  updateCalendar,
} from "../../store";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
import { addMinutes, format } from "date-fns";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 500 },
  overflow: "auto",
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Calendar = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getCalendars,
  getCalendarsReducer,
  createCalendar,
  updateCalendar,
  deleteCalendar,
}) => {
  let user = cookies.get("loginDetailsForWMS");
  // let role = user.data.data.role;
  let roleName = user.data.roleName;
  let roleId = user.data.roleId;
  let userId = user.data.userId;
  let jwtToken = user?.jwt;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let calendarModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "1c3670ab-dcab-4e95-a632-a2fd1287bf16",
  );

  let createAccess = calendarModule
    ? calendarModule.actionId.includes("c0b07231-26ee-49fa-a5d9-1b06cd4d2b64")
    : null;

  let updateAccess = calendarModule
    ? calendarModule.actionId.includes("bf2be0df-f950-49d5-8084-93ac6ad7a159")
    : null;

  let deleteAccess = calendarModule
    ? calendarModule.actionId.includes("ca955b2d-9ff9-4172-aa21-20aea22a818b")
    : null;

  let viewAccess = calendarModule
    ? calendarModule.actionId.includes("f4765f54-9942-436c-aef4-f1f958e24db7")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  useEffect(() => {
    viewAccess && getCalendars(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewAccess, pageNo, rowsPerPage, searchObject]);

  const [state, setState] = useState({
    columns: [
      {
        Header: "Date",
        accessor: "start",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy",
              )
            : "";
        },
      },
      {
        Header: "Event",
        accessor: "title",
        align: "left",
      },
      {
        Header: "Action",
        accessor: "action",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [loading, setLoading] = useState(false);

  const [errorMsgForCreate, setErrorMsgForCreate] = useState(false);

  useEffect(() => {
    let tempCalendar = [];
    let data = getCalendarsReducer.calendars.data
      ? getCalendarsReducer.calendars.data
      : [];

    setLoading(getCalendarsReducer.loading);

    setPaginationObj(getCalendarsReducer.calendars.pagination);
    data.map((calendar) => {
      const calendarObject = {
        start: calendar?.start,
        end: calendar?.end,
        title: calendar.title === undefined ? "-" : calendar.title,

        action: (
          <div>
            <EditButton
              tooltip="Edit Calendar"
              disabled={!updateAccess}
              variant="gradient"
              color="success"
              iconOnly
              type="button"
              onClick={() => handleOpenUpdateCalendarModal(calendar)}
              style={{ marginRight: "5px" }}
            >
              <Icon>edit_sharp</Icon>
            </EditButton>

            <DeleteButton
              tooltip="Delete Calendar"
              disabled={!deleteAccess}
              variant="gradient"
              color="error"
              iconOnly
              type="button"
              onClick={() => handleOpenDeleteCalendarModal(calendar)}
            >
              <Icon>delete</Icon>
            </DeleteButton>
          </div>
        ),
      };
      tempCalendar.push(calendarObject);
    });

    setState({ ...state, rows: tempCalendar });
  }, [getCalendarsReducer]);

  const initialValues = {
    dates: [
      {
        date: "",
        title: "",
      },
    ],
  };

  const validationSchema = Yup.object({
    // date: Yup.string().required("Enter the date"),
    // reason: Yup.string().required("Enter the reason"),
  });

  const onSubmitForLineItems = async (values, { resetForm }) => {
    const { dates } = values;

    const payloads = [];

    for (let index = 0; index < dates.length; index++) {
      const payload = {
        // index: index,
        start: dates[index]?.date,
        end: dates[index]?.date,
        title: dates[index]?.title,
      };
      payloads.push(payload);
    }

    const res = await createCalendar(payloads, jwtToken);

    if (res.status) {
      setIsSuccessCreatedGrn(true);
      getCalendars(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCreateGrnModal();
      }, 3000);
    }

    if (!res.status) {
      setIsErrorCreatedGrn(true);
      setErrorMsgForCreate(
        res.data.data.message ? res.data.data.message : res?.data?.data?.msg,
      );
    }
  };

  const [isSuccessCreatedGrn, setIsSuccessCreatedGrn] = useState(false);
  const [isErrorCreatedGrn, setIsErrorCreatedGrn] = useState(false);

  useEffect(() => {
    if (isErrorCreatedGrn) {
      setTimeout(() => {
        setIsErrorCreatedGrn(false);
      }, 3000);
    }
  }, [isErrorCreatedGrn]);

  useEffect(() => {
    if (isSuccessCreatedGrn) {
      setTimeout(() => {
        setIsSuccessCreatedGrn(false);
      }, 3000);
    }
  }, [isSuccessCreatedGrn]);

  // const formik = useFormik({
  //   initialValues,
  //   onSubmit,
  //   validationSchema,
  // });

  const [createGrnModal, setCreateGrnModal] = useState(false);
  const handleCreateGrnModal = () => {
    // formik.setValues(initialValues);
    // formik.setTouched({});
    // formik.setErrors({});

    setCreateGrnModal(!createGrnModal);
  };

  const [openDeleteCalendarModal, setOpenDeleteCalendarModal] = useState(false);
  const [singleCalendarDataForDelete, setCalendarDataForDelete] = useState({});
  const handleOpenDeleteCalendarModal = (calendar = {}) => {
    setCalendarDataForDelete(calendar);
    setOpenDeleteCalendarModal(true);
  };
  const handleCloseDeleteCalendarModal = () => {
    setOpenDeleteCalendarModal(false);
  };

  const [openUpdateCalendarModal, setOpenUpdateCalendarModal] = useState(false);
  const [singleCalendarDataForUpdate, setCalendarDataForUpdate] = useState({});
  const handleOpenUpdateCalendarModal = (calendar = {}) => {
    setCalendarDataForUpdate(calendar);
    setOpenUpdateCalendarModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateCalendarModal = () => {
    setOpenUpdateCalendarModal(false);

    formikForUpdate.setValues(initialValueForUpdate);
    formikForUpdate.setTouched({});
    formikForUpdate.setErrors({});
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    calendarId: singleCalendarDataForUpdate.id,
    start: singleCalendarDataForUpdate?.start,
    title: singleCalendarDataForUpdate.title,
  };

  const validationSchemaForUpdate = Yup.object({
    title: Yup.string().required("Enter the event!"),
  });

  const [updateErrorMsg, setUpdateErrorMsg] = useState("");

  const onSubmitForUpdate = async (values) => {
    let payload = {
      id: values.calendarId,
      start: values.start,
      end: values.start,
      title: values.title,
    };

    let res = await updateCalendar(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getCalendars(pageNo, rowsPerPage, searchObject, jwtToken);
    }
    if (!res.status) {
      setUpdateErrorMsg(
        res.data.data.message ? res.data.data.message : res?.data?.data?.msg,
      );
      setIsErrorForUpdate(true);
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  const [isErrorDeleteCalendar, setIsErrorDeleteCalendar] = useState(false);
  const [isSuccessDeleteCalendar, setIsSuccessDeleteCalendar] = useState(false);

  useEffect(() => {
    if (isErrorDeleteCalendar) {
      setTimeout(() => {
        setIsErrorDeleteCalendar(false);
      }, 3000);
    }
  }, [isErrorDeleteCalendar]);

  useEffect(() => {
    if (isSuccessDeleteCalendar) {
      setTimeout(() => {
        setIsSuccessDeleteCalendar(false);
      }, 3000);
    }
  }, [isSuccessDeleteCalendar]);

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");

  const deleteCalendarData = async () => {
    let calendarId = singleCalendarDataForDelete.id;

    let response = await deleteCalendar(calendarId, jwtToken);
    if (response.status) {
      getCalendars(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseDeleteCalendarModal();
      }, 4000);

      setIsSuccessDeleteCalendar(true);
    }
    if (!response.status) {
      setDeleteErrorMsg(
        response.data.data.message
          ? response.data.data.message
          : response?.data?.data?.msg,
      );
      setIsErrorDeleteCalendar(true);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={1} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-3}
                mt={-3}
              >
                <MDBox mt={4}>
                  <CreateButton
                    tooltip="Add Event"
                    disabled={!createAccess}
                    color="info"
                    variant="contained"
                    type="button"
                    style={{ marginRight: "10px" }}
                    onClick={handleCreateGrnModal}
                  >
                    Add Event
                  </CreateButton>
                </MDBox>
              </MDBox>

              <MDBox pt={1}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  serverSidePagination={true}
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                />
              </MDBox>
              <Modal
                open={createGrnModal}
                onClose={handleCreateGrnModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Add Event
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCreateGrnModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={0} pb={1} px={0}>
                    <MDBox
                    // component="form"
                    // role="form"
                    // onSubmit={formik.handleSubmit}
                    >
                      <MDBox>
                        <Formik
                          initialValues={initialValues}
                          validationSchema={validationSchema}
                          onSubmit={onSubmitForLineItems}
                        >
                          {(formik) => (
                            <Form>
                              <div>
                                <div>
                                  <FieldArray name="dates">
                                    {({ insert, remove, push }) => (
                                      <div>
                                        {formik.values.dates.length > 0 &&
                                          formik.values.dates.map(
                                            (lineItem, index) => (
                                              <MDBox
                                                display="flex"
                                                flexDirection={{
                                                  xs: "column",
                                                  lg: "row",
                                                }}
                                                key={index}
                                              >
                                                <MDBox mr={2}>
                                                  <MDTypography variant="h6">
                                                    Date
                                                  </MDTypography>

                                                  <Field
                                                    style={{
                                                      width: "230px",
                                                      borderRadius: 10,
                                                      marginLeft: 0,

                                                      height: 35,
                                                      // paddingLeft: "15px",
                                                    }}
                                                    type="date"
                                                    min={format(
                                                      new Date(),
                                                      "yyyy-MM-dd",
                                                    )}
                                                    className="form-control"
                                                    name={`dates.${index}.date`}
                                                    fullWidth
                                                    autoComplete="off"
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    value={formik.values.date}
                                                    error={
                                                      formik.touched.date &&
                                                      formik.errors.date &&
                                                      true
                                                    }
                                                    inputProps={{
                                                      style: {
                                                        height: "14px",
                                                      },
                                                      maxLength: 45,
                                                    }}
                                                  />

                                                  {formik.touched.date &&
                                                    formik.errors.date && (
                                                      <TextError
                                                        msg={formik.errors.date}
                                                      />
                                                    )}
                                                </MDBox>

                                                <MDBox>
                                                  <MDTypography variant="h6">
                                                    Event
                                                  </MDTypography>

                                                  <Field
                                                    style={{
                                                      borderRadius: 10,
                                                      marginLeft: 0,
                                                      height: 35,
                                                      // paddingLeft: "15px",
                                                    }}
                                                    type="text"
                                                    maxLength={45}
                                                    className="form-control"
                                                    name={`dates.${index}.title`}
                                                    fullWidth
                                                    autoComplete="off"
                                                    onChange={
                                                      formik.handleChange
                                                    }
                                                    value={formik.values.title}
                                                    error={
                                                      formik.touched.title &&
                                                      formik.errors.title &&
                                                      true
                                                    }
                                                    inputProps={{
                                                      style: {
                                                        height: "14px",
                                                      },
                                                      maxLength: 45,
                                                    }}
                                                  />

                                                  {formik.touched.title &&
                                                    formik.errors.title && (
                                                      <TextError
                                                        msg={
                                                          formik.errors.title
                                                        }
                                                      />
                                                    )}
                                                </MDBox>

                                                <div
                                                  className="col"
                                                  style={{ marginTop: "20px" }}
                                                >
                                                  {index > 0 && (
                                                    <CancelIcon
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      type="button"
                                                      className="secondary"
                                                      onClick={() =>
                                                        remove(index)
                                                      }
                                                      color="error"
                                                    />
                                                  )}
                                                  {/* <hr
                                                    style={{
                                                      marginTop: "1rem",
                                                    }}
                                                  /> */}
                                                </div>
                                              </MDBox>
                                            ),
                                          )}
                                        <div style={{ marginTop: "0.1rem" }}>
                                          <Tooltip title="Add ">
                                            <AddCircleIcon
                                              fontSize="large"
                                              onClick={() =>
                                                push({
                                                  date: "",
                                                  title: "",
                                                })
                                              }
                                              color="info"
                                              style={{
                                                width: "30px",
                                                marginLeft: "0rem",
                                                cursor: "pointer",
                                              }}
                                            />
                                          </Tooltip>
                                        </div>

                                        <MDButton
                                          style={{
                                            position: "sticky",
                                            bottom: "0",
                                          }}
                                          color="info"
                                          fullWidth
                                          type="submit"
                                          disabled={formik.values.dates.some(
                                            (item) =>
                                              item.date === "" ||
                                              item.title === "",
                                          )}
                                        >
                                          Submit
                                        </MDButton>
                                      </div>
                                    )}
                                  </FieldArray>
                                </div>
                              </div>

                              <MDBox>
                                <Collapse in={isErrorCreatedGrn}>
                                  <Alert
                                    severity="error"
                                    action={
                                      <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={() => {
                                          setIsErrorCreatedGrn(false);
                                        }}
                                      >
                                        <CloseIcon fontSize="inherit" />
                                      </IconButton>
                                    }
                                  >
                                    {errorMsgForCreate}
                                  </Alert>
                                </Collapse>
                                <Collapse in={isSuccessCreatedGrn}>
                                  <Alert
                                    severity="success"
                                    action={
                                      <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={() => {
                                          setIsSuccessCreatedGrn(false);
                                        }}
                                      >
                                        <CloseIcon fontSize="inherit" />
                                      </IconButton>
                                    }
                                  >
                                    Calendar Created Successfully
                                  </Alert>
                                </Collapse>
                              </MDBox>
                            </Form>
                          )}
                        </Formik>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>

              <Modal
                open={openUpdateCalendarModal}
                onClose={handleCloseUpdateCalendarModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Update Calendar
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseUpdateCalendarModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={0} pb={1} px={0}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForUpdate.handleSubmit}
                    >
                      <MDBox mb={2}>
                        <MDTypography variant="h6">Event</MDTypography>

                        <MDInput
                          type="text"
                          name="title"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForUpdate.handleBlur}
                          onChange={formikForUpdate.handleChange}
                          value={formikForUpdate.values.title}
                          error={
                            formikForUpdate.touched.title &&
                            formikForUpdate.errors.title &&
                            true
                          }
                          inputProps={{
                            style: {
                              height: "40px",
                            },
                            maxLength: 45,
                          }}
                        />

                        {formikForUpdate.touched.title &&
                          formikForUpdate.errors.title && (
                            <TextError msg={formikForUpdate.errors.title} />
                          )}
                      </MDBox>

                      <MDBox>
                        <Collapse in={isErrorForUpdate}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {updateErrorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessForUpdate}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Calendar updated successfully
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDButton
                          variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={!formikForUpdate.isValid}
                        >
                          Submit
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openDeleteCalendarModal}
                onClose={handleCloseDeleteCalendarModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={deleteStyle}>
                  <MDTypography>Are you sure you want to delete?</MDTypography>
                  <MDBox mt={2} display="flex">
                    <div>
                      <MDButton
                        style={{ width: "100%", marginRight: "0.5rem" }}
                        color="info"
                        variant="outlined"
                        onClick={handleCloseDeleteCalendarModal}
                      >
                        Cancel
                      </MDButton>
                    </div>
                    <div style={{ float: "right" }}>
                      <MDButton
                        style={{ width: "100%", marginLeft: "0.5rem" }}
                        color="error"
                        onClick={deleteCalendarData}
                      >
                        Delete
                      </MDButton>
                    </div>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isErrorDeleteCalendar}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorDeleteCalendar(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {deleteErrorMsg}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessDeleteCalendar}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessDeleteCalendar(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Calendar deleted successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getCalendarsReducer: state.getCalendarsReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getCalendars: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getCalendars(pageNo, rowsPerPage, searchObject, jwtToken)),
    createCalendar: (payload, jwtToken) =>
      dispatch(createCalendar(payload, jwtToken)),
    updateCalendar: (payload, jwtToken) =>
      dispatch(updateCalendar(payload, jwtToken)),
    deleteCalendar: (calendarId, jwtToken) =>
      dispatch(deleteCalendar(calendarId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(Calendar);
